/**
 * SEO defaults and per-page metadata for projectskart.in.
 * Used by src/components/SEO.js:  <SEO {...seoConfig.pages.contact} />
 *
 * Page titles are short; SEO.js appends " | Projects Kart".
 */

export const seoConfig = {
  siteName: 'Projects Kart',
  siteUrl: 'https://www.projectskart.in',

  defaultTitle: 'Projects Kart – Ready-made projects with source code',
  defaultDescription:
    'Ready-made software projects with source code: web, mobile, machine learning, data science, IoT, blockchain and desktop apps. Prices in INR, pay by UPI.',

  pages: {
    home: {
      title: 'Projects Kart – Ready-made projects with source code',
      description:
        'Ready-made software projects with source code: web, mobile, machine learning, data science, IoT, blockchain and desktop apps. Prices in INR, pay by UPI.',
      path: '/',
    },
    products: {
      title: 'All projects',
      description:
        'Browse ready-made software projects with source code. Each project page lists what you get, the tech stack and the price in INR.',
      path: '/products',
    },
    about: {
      title: 'About',
      description:
        'Projects Kart sells ready-made software projects with source code. Pay by UPI; we verify each payment by hand and give you access from your order page.',
      path: '/about',
    },
    contact: {
      title: 'Contact',
      description:
        'Questions about a project or an order? Send us a message or reach us on WhatsApp, Monday to Friday, 9 AM to 6 PM IST.',
      path: '/contact',
    },
    howWeWork: {
      title: 'How it works',
      description:
        'Choose a project, pay by UPI QR, and get access from your order page once we verify the payment, typically within 12 hours.',
      path: '/how-we-work',
    },
    reviews: {
      title: 'Customer reviews',
      description:
        'Ratings and reviews from Projects Kart customers, with the project each review is about.',
      path: '/reviews',
    },
    videos: {
      title: 'Project videos',
      description:
        'Walkthrough and demo videos of projects from the Projects Kart catalog.',
      path: '/videos',
    },
    requestProject: {
      title: 'Request a project',
      description:
        'Need a project that is not in the catalog? Tell us what you need, your budget and timeline, and we will get back to you.',
      path: '/request-project',
    },
    githubProjects: {
      title: 'Free source code',
      description:
        'Free source code from the Projects Kart YouTube channel: watch the video, then get the code on GitHub or as a download.',
      path: '/code',
    },
    terms: {
      title: 'Terms of Service',
      description:
        'The terms for using Projects Kart and buying projects: UPI payment, order processing, licence and the no-refund policy.',
      path: '/terms',
    },
    privacy: {
      title: 'Privacy Policy',
      description:
        'What information Projects Kart collects, how it is used and protected, and your choices.',
      path: '/privacy',
    },
    refund: {
      title: 'Refund Policy',
      description:
        'All sales on Projects Kart are final. Read what that means and how we help if something goes wrong.',
      path: '/refund',
    },
  },
};

/** Props for <SEO> for a page in seoConfig.pages (falls back to the home page). */
export const getPageMeta = pageName =>
  seoConfig.pages[pageName] || seoConfig.pages.home;

export default seoConfig;
